// import Vue from 'vue'
// import Vuex from 'vuex'

// Vue.use(Vuex)

const productDataReport = {
  namespaced: true,
  state: {
    selected: {
      customReportLink: null
    }
  },
  mutations: {
    selected (state, payload) {
      state.selected[payload.prop] = payload.value
    },
    setDefaultState (state) {
      state.postReport = {
        error: false,
        loading: false,
        response: null
      }
    },
    overwriteSelected (state, newVal) {
      state.selected = newVal
    },
    setDefaultSelectionState (state) {
      state.selected = {
        customReportLink: null
      }
    }
  },
  getters: {
    getAllSelections: state => {
      return state.selected
    }
  },
  actions: {
    updateSelection ({ commit }, payload) {
      if (payload.propName) payload.prop = payload.propName // TODO: Harmonize payload interfaces
      commit('selected', payload)
    },
    loadStateFromFile ({ commit }, data) {
      commit('overwriteSelected', data)
    },
    reset ({ commit }) {
      commit('setDefaultState')
      commit('setDefaultSelectionState')
    }
  }
}
export default productDataReport
